import { createGlobalStyle } from "styled-components";
import colors from "./colors";

const ToastStyle = createGlobalStyle`
  /* Estilos customizados para Toastify v11 (compatibilidade com v5) */
  .Toastify__toast {
    font-family: "Roboto", sans-serif;
    border-radius: 4px;
    box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1), 0 2px 15px 0 rgba(0, 0, 0, 0.05);

    a {
      color: ${colors.text.white};
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .Toastify__toast--success {
    background-color: ${colors.toast.success};
    color: ${colors.text.white};
  }

  .Toastify__toast--error {
    background-color: ${colors.toast.error};
    color: ${colors.text.white};
  }

  .Toastify__toast--info {
    background-color: ${colors.toast.info};
    color: ${colors.text.white};
  }

  .Toastify__toast--warning {
    background-color: ${colors.toast.warning};
    color: ${colors.text.white};
  }

  .Toastify__progress-bar-container {
    height: 8px;
  }

  .Toastify__progress-bar {
    height: 8px;
    background: rgba(255, 255, 255, 0.7);
  }

  .Toastify__progress-bar--success {
    background: rgba(255, 255, 255, 0.7);
  }

  .Toastify__progress-bar--error {
    background: rgba(255, 255, 255, 0.7);
  }

  .Toastify__progress-bar--info {
    background: rgba(255, 255, 255, 0.7);
  }

  .Toastify__progress-bar--warning {
    background: rgba(255, 255, 255, 0.7);
  }

  /* Mantém compatibilidade com classe .toast antiga */
  .toast {
    a {
      color: ${colors.text.white};
      text-decoration: none;
    }
  }
`;

export default ToastStyle;
